/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {BetLinesView} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {NearWinReelDivider} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {IStillImageBackground} from "./background/IStillImageBackground";
import {ForegroundAnimation} from "./foregroundanimation/ForegroundAnimation";
import {RESymbolIdleAnimationController} from "./idleanimation/RESymbolIdleAnimationController";
import {REReelAreaView} from "./Reel/REReelAreaView";
import {REReelStopPresentationController} from "./Reel/REReelStopPresentationController";
import {RESpinReelPartAnimator} from "./Reel/RESpinReelPartAnimator";
import {RomanEmpireReelController} from "./Reel/RomanEmpireReelController";
import {RomanEmpireFontConfig} from "./RomanEmpireFontConfig";
import {RomanEmpireGameAssets} from "./RomanEmpireGameAssets";
import {RomanEmpireGameConfig} from "./RomanEmpireGameConfig";
import {RomanEmpireSoundConfig} from "./RomanEmpireSoundConfig";
import {ScatterAnimationController} from "./scatteranimation/ScatterAnimationController";
import {REGenieReSpinIntroController} from "./screens/genierespinintro/REGenieReSpinIntroController";
import {REGenieReSpinIntroView} from "./screens/genierespinintro/REGenieReSpinIntroView";
import {REGenieReSpinOutroController} from "./screens/genierespinoutro/REGenieReSpinOutroController";
import {REGenieReSpinOutroView} from "./screens/genierespinoutro/REGenieReSpinOutroView";
import {RomanEmpireParsedGameData} from "./server/data/RomanEmpireParsedGameData";
import {RomanEmpireParsedInitData} from "./server/data/RomanEmpireParsedInitData";
import {RomanEmpireServerDataParser} from "./server/RomanEmpireServerDataParser";
import {RomanEmpireReelSymbol} from "./symbols/RomanEmpireReelSymbol";
import {RomanEmpireReelSymbolStateCreator} from "./symbols/RomanEmpireReelSymbolStateCreator";
import {WalkingWild} from "./walkingwild/WalkingWild";
import {LineWin} from "./winpresentation/betline/LineWin";
import {REBetLinesView} from "./winpresentation/betline/REBetLinesView";
import {RETextBetLineNumber} from "./winpresentation/betline/RETextBetLineNumber";
import {RomanEmpirePolyBetLine} from "./winpresentation/betline/RomanEmpirePolyBetLine";
import {RomanEmpireBigWinController} from "./winpresentation/bigwin/RomanEmpireBigWinController";
import {GenieFeatureController} from "./winpresentation/geniefeature/GenieFeatureController";
import {REBetLineWinIndividualWPController} from "./winpresentation/indiividual/REBetLineWinIndividualWPController";
import {RomanEmpireInitialWPController} from "./winpresentation/initial/RomanEmpireInitialWPController";
import {RENoWinSymbolsWinPresentationController} from "./winpresentation/nowin/RENoWinSymbolsWinPresentationController";
import {RomanEmpireShakeEffect} from "./winpresentation/romanEmpireShakeEffect/RomanEmpireShakeEffect";
import {REReSpinZeroBetController} from "./zerobet/REReSpinZeroBetController";
import {FeaturePrice} from "./server/data/FeaturePrice";

export class RomanEmpireGameModuleConfig implements IGameModuleConfig {

    public static instance:RomanEmpireGameModuleConfig = new RomanEmpireGameModuleConfig();
    private static gameTweakerTest:GameTweakerTest;
    private static background:StillImageBackground;
    private static reelDivider:NearWinReelDivider;
    private static betLinesView:BetLinesView;
    public static scatterAnim:ScatterAnimationController;
    private static romanEmpireShakeEffect:RomanEmpireShakeEffect;
    public static featurePrice:FeaturePrice;


    public static foregroundAnimation:ForegroundAnimation;
    //private static reelBackground: RomanEmpireReelBackground;
    public static reelArea:StillImageBackground;

    GAME_CONFIG:IGameConfig = RomanEmpireGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = RomanEmpireSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = RomanEmpireFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = RomanEmpireGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new RomanEmpireServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData =
        (data, dataParser:ServerDataParser) => new RomanEmpireParsedInitData(data, <RomanEmpireServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData =
        (data, dataParser:ServerDataParser) => new RomanEmpireParsedGameData(data, <RomanEmpireServerDataParser>dataParser);

    REEL_AREA_VIEW:() => ReelAreaView = () => new REReelAreaView();

    REEL_PART_ANIMATOR:(reelId:number) => ReelPartAnimator = reelId => new RESpinReelPartAnimator(reelId);
    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new RomanEmpireReelController(reelId);

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new REReelStopPresentationController(index)
    ];

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    // REEL_PART_ANIMATOR?:(callbacks:ReelPartAnimatorCallbacks, reelId:number) => ReelPartAnimator; // Default new ReelPartAnimator.

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):RomanEmpireReelSymbol => {
            return new RomanEmpireReelSymbol(symName, reelId, state);
        });

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new RomanEmpireReelSymbolStateCreator();

    SCREENS:(() => ScreenController)[] = [
        () => new REGenieReSpinIntroController({
            viewCreator : (onButtonClickCallback:() => void) => {
                return new REGenieReSpinIntroView({
                    layer : RomanEmpireGameConfig.instance.LAYERS.FREE_SPIN_INTRO.name,
                    buttonTextStyle : (
                        new PIXI.TextStyle({
                            fill : "#ffffff",
                            fontFamily : OpenSans.FAMILY,
                            fontSize : 22,
                            fontStyle : FontStyle.ITALIC,
                            fontWeight : FontWeight.EXTRA_BOLD,
                            padding : 10
                        })
                    ),
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.4
                    },
                    portraitScale : 1,
                    onButtonClickCallback : onButtonClickCallback
                });
            }
        }),
        () => new REGenieReSpinOutroController({
            viewCreator : (onButtonClickCallback:() => void) => {
                return new REGenieReSpinOutroView({
                    layer : RomanEmpireGameConfig.instance.LAYERS.FREE_SPIN_OUTRO.name,
                    buttonTextStyle : (
                        new PIXI.TextStyle({
                            fill : "#ffffff",
                            fontFamily : OpenSans.FAMILY,
                            fontSize : 22,
                            fontStyle : FontStyle.ITALIC,
                            fontWeight : FontWeight.EXTRA_BOLD,
                            padding : 10
                        })
                    ),
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.4
                    },
                    portraitScale : 1,
                    onButtonClickCallback : onButtonClickCallback
                });
            }
        })
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new REReSpinZeroBetController()
    ];


    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new GenieFeatureController(indexes, {name : "genieFeature", skippable : true})],
        [indexes => new RENoWinSymbolsWinPresentationController(indexes, {noWinStateFadeInDuration : 1})],
        [indexes => new RomanEmpireInitialWPController(indexes)],
        [indexes => new RomanEmpireShakeEffect(indexes, {name : "shake", skippable : true})],
        [indexes => new RomanEmpireBigWinController(indexes)]
    ];
    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new REBetLineWinIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0.5; //only for testing
        }
    });


    GAME_FEATURE_CREATOR:() => void = () => {
        RomanEmpireGameModuleConfig.gameTweakerTest = new GameTweakerTest();
        //RomanEmpireGameModuleConfig.reelBackground = new RomanEmpireReelBackground();
        StageManager.legacyScaling = false;
        //Idle aniamtion class object initialization
        new RESymbolIdleAnimationController();

        RomanEmpireGameModuleConfig.background = new IStillImageBackground({
            layer : RomanEmpireGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : RomanEmpireGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                GENIE_RESPIN : {
                    image : RomanEmpireGameAssets.BONUS_GAME_BACKGROUND,
                    offset : new PIXI.Point(-480, -480)
                }
            },
            stretch : false
        });
        RomanEmpireGameModuleConfig.reelArea = new StillImageBackground({
            layer : GameConfig.instance.LAYERS.REEL_BACKGROUND.name,
            backgroundImages : {
                NORMAL : {
                    image : RomanEmpireGameAssets.REEL_BACKGROUND,
                    offset : new PIXI.Point(-50, 0)
                },
                GENIE_RESPIN : {
                    image : RomanEmpireGameAssets.REEL_BACKGROUND,
                    offset : new PIXI.Point(-50, 0)
                }
            },
            stretch : false
        });

        // RomanEmpireGameModuleConfig.reelDivider = new NearWinReelDivider({
        //     layer: RomanEmpireGameConfig.instance.LAYERS.REEL_BACKGROUND.name,
        //     texturesGetter: (index: number) => {
        //         return GameResources.getTextures(RomanEmpireGameAssets.NORMAL_REEL_DIVIDER)
        //     },
        //     positions: [
        //         [GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y],
        //         [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH, GameConfig.instance.REEL_AREA_POS_Y],
        //         [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 2, GameConfig.instance.REEL_AREA_POS_Y],
        //         [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 3, GameConfig.instance.REEL_AREA_POS_Y],
        //         [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 4, GameConfig.instance.REEL_AREA_POS_Y],
        //         [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 5, GameConfig.instance.REEL_AREA_POS_Y]
        //     ],
        //     nearWinLayer: RomanEmpireGameConfig.instance.LAYERS.REEL_ATTENTION.name,
        //     nearWinTexturesGetter: (index: number) => {
        //         return GameResources.getTextures(RomanEmpireGameAssets.NEAR_WIN_REEL_DIVIDER)
        //     },
        //     reelIndexMap: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5]]
        // });

        RomanEmpireGameModuleConfig.betLinesView = new REBetLinesView(
            {
                map : [
                    4, 2, 6, 8, 1, 10, 9, 7, 3, 5, // left
                    12, 18, 20, 16, 11, 14, 15, 17, 13, 19 // right
                ]
            },
            (index:number):RETextBetLineNumber => {
                return new RETextBetLineNumber(index, {
                    layer : RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name,
                    width : 40,
                    height : 40,
                    horizontalPadding : GameConfig.instance.REEL_AREA_POS_X - 25,
                    verticalPadding : [
                        GameConfig.instance.REEL_AREA_POS_Y + 40,
                        (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT)) + 40
                    ],
                    textStyleNormal : {
                        fontFamily : "Open Sans",
                        fontSize : 20,
                        fill : "#a6759a"
                    },
                    textStyleWin : {
                        fontFamily : "Open Sans",
                        fontSize : 30,
                        fill : "#ffffff",
                        stroke : "#dfb8cd",
                        strokeThickness : 2,
                        padding : 4

                    },
                    textWinScale : 1
                });
            },
            (index:number, numberPosition:number[], betLineData:number[]):PolyBetLine => {
                return new RomanEmpirePolyBetLine(index, numberPosition, betLineData, {
                    staticLineLayer : RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name,
                    styles : [
                        {
                            "lineWidth" : 6,
                            "color" : 0xffffff,
                            "alpha" : 1
                        },
                        {
                            "lineWidth" : 3,
                            "color" : 0xdfb8cd,
                            "alpha" : 1
                        }
                    ],
                    numberOffsetX : 20,
                    pointOverlapVerticalOffset : 8
                });
            }
        );
        // TODO: add all features here...
        const walkingWilds:WalkingWild = new WalkingWild();
        RomanEmpireGameModuleConfig.scatterAnim = new ScatterAnimationController();
        RomanEmpireGameModuleConfig.foregroundAnimation = new ForegroundAnimation();
        // RomanEmpireGameModuleConfig.romanEmpireShakeEffect = new RomanEmpireShakeEffect();
        const lineWin = new LineWin();
        RomanEmpireGameModuleConfig.featurePrice = new FeaturePrice();

    };

    constructor() {
        if(RomanEmpireGameModuleConfig.instance) {
            throw new Error("RomanEmpireGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}